// extracted by mini-css-extract-plugin
export default {"addressAction":"J6-z","loading":"K6-z"};